import React, { useState } from 'react'

import { server } from '../../modules'

import Modal from '../reusable/modal'

const PrintIFrame = ({ toggle, visible, title, id, content }) => {
    return (
        <Modal
            w={ 600 }
            title={ title }
            toggle={toggle}
            visible={visible}>
            <iframe width="100%" height="568px" src={ `${server}/${content}/${id}/print` } />
        </Modal>
    )
}

export default PrintIFrame